import React, { useState, useEffect } from "react";
import {
  Image,
  ActivityIndicator,
  ImageBackground,
  Pressable,
  Text,
  View,
  StyleSheet,
} from "react-native";
import PlusIcon from "@assets/svg/PlusThin";
import colors from "@constants/color";
import AttachPin from "../../assets/svg/KYCSetup/AttachPin";
import DeleteBin from "../../assets/svg/KYCSetup/DeleteBin";

const Photo = (props) => {
  const {
    source = "",
    disabled = false,
    onUpload = () => {},
    onDelete = () => {},
    ctaText,
    style,
    imgStyle,
    variant = "long",
    shouldResize = true,
  } = props;

  const [loading, setLoading] = useState(true);
  const [autoImgWidth, setAutoImgWidth] = useState(null);

  const _onLoadEnd = () => {
    setLoading(false);
  };

  const _onPress = () => {
    onUpload();
  };

  const LongButton = () => (
    <Pressable
      disabled={disabled}
      onPress={_onPress}
      android_ripple={{
        color: "rgba(0,0,0,0.08)",
        borderless: false,
      }}
      style={styles.uploadPhotoButton}
    >
      <AttachPin style={{ marginRight: 10 }} />
      <Text>{ctaText}</Text>
    </Pressable>
  );

  const ShortButton = () => (
    <Pressable
      onPress={_onPress}
      android_ripple={{
        color: "rgba(0,0,0,0.08)",
        borderless: false,
      }}
      style={styles.shortUploadPhotoButton}
    >
      <PlusIcon />
      <Text
        style={{ fontSize: 12, color: colors.primary, textAlign: "center" }}
      >
        {ctaText}
      </Text>
    </Pressable>
  );

  const UploadButton = variant === "long" ? LongButton : ShortButton;

  useEffect(() => {
    if (source && shouldResize) {
      Image.getSize(source, (w, h) => {
        const size = (w / h) * 100;
        // +6 fixes the bug where image isnt visible;
        setAutoImgWidth(size + 6);
      });
    }
  }, [source, shouldResize]);

  const autoResizeStyles =
    source && shouldResize ? { width: autoImgWidth || "50%" } : {};

  console.log(source);
  return (
    <View style={[styles.photosRow, style]}>
      {source ? (
        <ImageBackground
          source={{ uri: source }}
          style={[styles.photo, imgStyle, autoResizeStyles]}
          resizeMode="contain"
          onLoadEnd={_onLoadEnd}
        >
          {loading ? (
            <View style={styles.loading}>
              <ActivityIndicator size="large" color={colors.primary} />
            </View>
          ) : (
            !disabled && <ClearButton onClear={onDelete} />
          )}
        </ImageBackground>
      ) : (
        <UploadButton />
      )}
    </View>
  );
};

const ClearButton = (props) => {
  const { onClear = () => {} } = props;
  return (
    <Pressable
      onPress={onClear}
      style={styles.deleteBin}
      android_ripple={{ color: "rgba(0,0,0,0.08)", borderless: true }}
    >
      <DeleteBin />
    </Pressable>
  );
};

export default Photo;

const styles = StyleSheet.create({
  deleteBin: {
    marginLeft: "auto",
    padding: 2,
  },

  photosRow: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.2)",
    // flex: 1,
    overflow: "hidden",
  },
  uploadPhotoButton: {
    flexDirection: "row",
    backgroundColor: "#E5E5E5",
    marginVertical: 30,
    marginHorizontal: 10,
    padding: 12,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 6,
  },
  shortUploadPhotoButton: {
    height: 105,
    width: 105,
    backgroundColor: "rgba(0,0,0,0.05)",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 10,
  },
  photo: {
    height: 105.1,
    overflow: "hidden",
  },

  loading: {
    flex: 1,
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
  },
});
